module.exports = __webpack_public_path__ + "img/icon-cart-outline.650c6363.svg";